// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zvhi","col":"styles_col__1to0y"};